export const PaymentGateway = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        d="M25.825 11.5858H20.4487V6.17863C20.4487 3.0579 17.8996 0.508789 14.7789 0.508789H6.17373C3.05301 0.508789 0.503906 3.0579 0.503906 6.17863V25.8299C0.503906 28.9506 3.05301 31.4997 6.17373 31.4997H11.72C11.72 31.4997 11.7972 31.4997 11.8436 31.4997H25.825C28.9457 31.4997 31.4948 28.9506 31.4948 25.8299V17.2402C31.4948 14.1195 28.9457 11.5704 25.825 11.5704V11.5858ZM29.332 17.2556V17.7964H8.3366V17.2556C8.3366 15.3245 9.91242 13.7487 11.8436 13.7487H25.825C27.7562 13.7487 29.332 15.3245 29.332 17.2556ZM2.66677 25.8299V6.17863C2.66677 4.24749 4.24259 2.67167 6.17373 2.67167H14.7789C16.71 2.67167 18.2858 4.24749 18.2858 6.17863V11.5858H11.8436C8.72283 11.5858 6.17373 14.1349 6.17373 17.2556V25.8454C6.17373 27.174 6.65266 28.3636 7.40967 29.3369H6.17373C4.24259 29.3369 2.66677 27.7611 2.66677 25.8299ZM25.825 29.3523H14.8407C14.8407 29.3523 14.7944 29.3523 14.7789 29.3523H11.72C9.85062 29.2905 8.3366 27.7456 8.3366 25.8608V20.8089H29.332V25.8608C29.332 27.7919 27.7562 29.3678 25.825 29.3678V29.3523Z"
        fill="#424242"
      />
      <path
        d="M30.3978 9.39227C30.4751 9.39227 30.5677 9.39228 30.645 9.36138C31.2321 9.22234 31.5874 8.65073 31.4638 8.06366C30.6141 4.34042 27.6479 1.37418 23.9246 0.524481C23.3376 0.400888 22.7659 0.756216 22.6269 1.34328C22.4878 1.93035 22.8586 2.50197 23.4457 2.64101C26.3656 3.30533 28.6829 5.63815 29.3627 8.55803C29.4863 9.0524 29.9189 9.39227 30.4133 9.39227H30.3978Z"
        fill="url(#paint0_linear_8363_192768)"
      />
      <path
        d="M26.0884 8.35717C26.1657 8.88244 26.6291 9.26867 27.1544 9.26867C27.2162 9.26867 27.2626 9.26867 27.3243 9.26867C27.9114 9.17598 28.3131 8.6198 28.2204 8.03274C27.8651 5.83896 26.1657 4.12411 23.9719 3.78423C23.4003 3.70698 22.8287 4.09321 22.736 4.68028C22.6433 5.26735 23.0449 5.82351 23.632 5.9162C24.8988 6.11704 25.8876 7.10579 26.0884 8.37262V8.35717Z"
        fill="url(#paint1_linear_8363_192768)"
      />
      <path
        d="M22.3828 8.17203C22.3828 8.91359 22.9853 9.53155 23.7423 9.53155C24.4993 9.53155 25.1018 8.92904 25.1018 8.17203C25.1018 7.41502 24.4993 6.8125 23.7423 6.8125C22.9853 6.8125 22.3828 7.41502 22.3828 8.17203Z"
        fill="url(#paint2_linear_8363_192768)"
      />
      <path
        d="M9.00331 6.0867H11.9232C12.5257 6.0867 13.0046 5.60778 13.0046 5.00526C13.0046 4.40275 12.5257 3.92383 11.9232 3.92383H9.00331C8.40079 3.92383 7.92188 4.40275 7.92188 5.00526C7.92188 5.60778 8.40079 6.0867 9.00331 6.0867Z"
        fill="#424242"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8363_192768"
          x1="22.596"
          y1="4.95838"
          x2="31.4792"
          y2="4.95838"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4C074" />
          <stop offset="0.34" stopColor="#E3B16A" />
          <stop offset="1" stopColor="#BE7B2B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8363_192768"
          x1="22.7205"
          y1="6.50328"
          x2="28.2359"
          y2="6.50328"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4C074" />
          <stop offset="0.34" stopColor="#E3B16A" />
          <stop offset="1" stopColor="#BE7B2B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8363_192768"
          x1="22.3828"
          y1="8.17202"
          x2="25.1018"
          y2="8.17202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4C074" />
          <stop offset="0.34" stopColor="#E3B16A" />
          <stop offset="1" stopColor="#BE7B2B" />
        </linearGradient>
      </defs>
    </svg>
  );
};
